import React from 'react';
import { motion } from 'framer-motion';
import { SearchPanel } from './SearchPanel';
export function Hero() {
  return <section className="bg-paper" data-id="element-92" data-mp="ej4mbu3165dv">
      <div className="mx-auto max-w-shell px-6 pb-20 pt-20 lg:px-10 lg:pb-28 lg:pt-28" data-id="element-93" data-mp="ehtk3yp8h5ov">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-3xl text-center" data-id="element-94" data-mp="9l33na9io82x">
          <p className="label text-olive" data-id="element-95" data-mp="xanoxzt57hfd">
            Santa Barbara · Montecito · Goleta · Carpinteria
          </p>

          <h1 className="mt-8 font-display text-[56px] font-300 leading-[0.95] text-ink sm:text-[76px] lg:text-[88px]" data-id="element-96" data-mp="sai535t46z7u">
            Where are we taking
            <br data-id="element-97" data-mp="neav91xll3km" />
            the kids <span className="italic" data-id="element-98" data-mp="3d1a99mbhsfec">today?</span>
          </h1>

          <p className="mx-auto mt-8 max-w-xl text-[16px] leading-[1.8] text-muted" data-id="element-99" data-mp="3czfl7z4xc761">
            Written by parents who live here. Every park, class, event and
            resource in one place — so you can stop scrolling and go.
          </p>

          <div className="mx-auto mt-14 max-w-2xl" data-id="element-100" data-mp="3o85ata00nz41">
            <SearchPanel align="center" data-id="element-101" data-mp="3o5j4tesrxrnx" />
          </div>
        </motion.div>
      </div>
    </section>;
}